import React from "react";
import "./Portfolio.css";
import IMG1 from "../../Assets/Images/mini-arcade.png";
import IMG2 from "../../Assets/Images/project-img1.png";
import IMG3 from "../../Assets/Images/project-img2.png";
import IMG4 from "../../Assets/Images/project-img3.png"; 
import IMG5 from "../../Assets/Images/techImage.png";   
import IMG10 from "../../Assets/Images/hooBank.png";

export default class Portfolio extends React.Component {
	render() {
		return (
			<section id="portfolio">
				<h5>My Recent Work</h5>
				<h2>Portfolio</h2>

				<div className="container portfolio__container">
					<article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG1} alt="Mini Arcade" />
                    </div>
                        <h3>Mini Arcade(SnakeVoltext)</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Mini-Arcade/mini-arcade" className='btn'target='_blank' rel="noreferrer">Github</a>
                        <a href="https://mini-arcade-201-l-m.netlify.app/snakev" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>
                    </article>

                    <article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG10} alt="Mini Arcade" />
                    </div>
                        <h3>UI HooBank</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Syntax-Read3r/ui-hoobank" className='btn'>Github</a>
                        <a href="https://main--warm-lokum-69b4f1.netlify.app/" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>

                    </article>

                    <article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG2} alt="Mini Arcade" />
                    </div>
                        <h3>Code Cookies</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Syntax-Read3r/cookie-stand" className='btn' target='_blank' rel="noreferrer">Github</a>
                        <a href="https://cookie-stand-munya.netlify.app/" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>

                    </article>

                    <article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG3} alt="Mini Arcade" />
                    </div>
                        <h3>Portfolio</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Syntax-Read3r/portfolio" className='btn'>Github</a>
                        <a href="https://syntax-read3r.netlify.app/" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>

                    </article>

                    <article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG4} alt="Mini Arcade" />
                    </div>
                        <h3>The Generics(Shopping CART)</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Syntax-Read3r/Javascript-Shopping-Cart" className='btn'>Github</a>
                        <a href="https://lovely-gnome-a25a48.netlify.app/" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>

                    </article>

                    <article className="portfolio__item">
                    <div className="portfolio__image">
                        <img src={IMG5} alt="Product Selling Page" />
                    </div>
                        <h3>Responsive Product Selling Page (Written in SASS)(</h3>
                        <div className="portfolio__cta">
                        <a href="https://github.com/Syntax-Read3r/responsive-website-in-scss.git" className='btn'>Github</a>
                        <a href="https://product-sells-page.netlify.app/" className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                        </div>

                    </article>

                


				</div>
			</section>
		);
	}
}
